module.exports = __webpack_public_path__ + "img/Thumbs_Up.c32ea700.svg";